import { resource } from '@data-client/rest';
import { AuthEndpoint } from '../endpoints/Auth';
export function authResource({ schema, Endpoint = AuthEndpoint, ...extraOptions }) {
    return resource({
        Endpoint,
        schema,
        ...extraOptions
    });
}
